<template>
    <dl>
        <template v-if="descriptors" v-for="(value, descriptor) in descriptors">
            <dt :key="descriptor">
                <span v-if="small">{{ trans(descriptor) }}</span>
                <small v-else>{{ trans(descriptor) }}</small>
            </dt>
            <dd :key="descriptor + value">
                <img v-if="value === true" src="../assets/icomoon/SVG/checkmark.svg" />
                <img v-else-if="value === false" src="../assets/icomoon/SVG/close.svg" />
                <span v-else>{{ value }}</span>
            </dd>
        </template>
    </dl>
</template>

<script>
export default {
    props: {
        descriptors: {
            type: Object,
            required: true,
            default: () => {}
        },
        small: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
